// src/landings/components/resources/CategoryHeader.tsx
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

interface CategoryHeaderProps {
  title: string;
  description: string;
  featuredImage?: string;
}

function CategoryHeader({ title, description, featuredImage }: CategoryHeaderProps) {
  return (
    <section className="py-12 px-4 relative">
      <div className="container mx-auto max-w-4xl">
        <motion.div
          className="flex items-center mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link
            to="/resources"
            className="text-[#8a7266] hover:text-[#694e42] flex items-center text-sm font-medium"
          >
            <svg
              className="w-4 h-4 mr-1"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 12H5M12 19l-7-7 7-7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            All Resources
          </Link>
        </motion.div>

        <div className="mb-4 inline-block">
          <div className="bg-[#fff5eb] px-4 py-2 rounded-full border border-[#ff8c42]/20">
            <span className="text-[#ff8c42] font-medium">{title}</span>
          </div>
        </div>

        <motion.h1
          className="text-3xl md:text-4xl font-bold mb-4 text-[#694e42]"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {title}
        </motion.h1>

        <motion.p
          className="text-lg text-[#8a7266] mb-8 max-w-3xl"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {description}
        </motion.p>

        {featuredImage && (
          <motion.div
            className="rounded-xl overflow-hidden mb-8 shadow-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <img
              src={featuredImage}
              alt={title}
              className="w-full h-auto"
            />
          </motion.div>
        )}
      </div>
    </section>
  );
}

export default CategoryHeader;